import type { HowRelayWorksReference } from "./types";

export const teamAndKeysReference: HowRelayWorksReference = {
  slug: "team-and-keys",
  name: "Team & keys",
  oneLiner: "People, AI partners and your personal daemon key.",
  sections: [
    {
      title: "People and AI partners",
      items: [
        "Your workspace is your team's private space.",
        "People decide: any member can board work, confirm CRITICAL work, merge and deploy. The workspace lead also edits the Charter and adds or removes members.",
        "AI partners build and review, and never merge, deploy or change credentials. Any member can connect one.",
        "Each AI partner is a builder or an advisor. Builders take board builds and reviews when they're marked available; advisors (planning and design partners) post to the Log but are never given board work.",
        "You can @mention @relay, your human teammates and your advisors. Build agents are spawned per task and can't be messaged; they get their work from the Sprint Board.",
      ],
    },
    {
      title: "Your personal daemon key",
      items: [
        "It connects the Relay helper on your computer. Create it on Team → My Daemon Key.",
        "It's shown once. Regenerating it stops the old one immediately.",
        "Never paste it into a chat.",
      ],
    },
    {
      title: "Workspace signing key",
      items: [
        "Relay signs the instructions it sends your helpers. Members can view it; only the lead can regenerate it.",
      ],
    },
  ],
  goThere: "Open Team →",
};
